export const safeJSONParse = (content?: string) => {
  try {
    if (!content) return null;

    return JSON.parse(content);
  } catch (error) {
    console.warn(`Fail to parse content: ${content}, ${error}`);
    return null;
  }
};
